import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = logged out
  const [institution, setInstitution] = useState(null);

  const refresh = async () => {
    const token = localStorage.getItem("oed_token");
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      setInstitution(data.institution || null);
    } catch {
      localStorage.removeItem("oed_token");
      setUser(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("oed_token", data.access_token);
    await refresh();
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("oed_token", data.access_token);
    await refresh();
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("oed_token");
    setUser(false);
    setInstitution(null);
  };

  return (
    <AuthContext.Provider value={{ user, institution, login, register, logout, refresh, setInstitution }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
